/**
 * @author caijianjia
 * @date 2020/3/14 3:43 下午
 */
const ele = 'IM-Audio'
let audio = document.getElementById(ele)
let state = false // 页面是否已存在音频元素
// let isPlaying = false // 页面是否正在播放音频
let TempIndex = -1 // 当前操作的临时索引
if (audio) {
    state = true
} else {
    audio = new Audio()
}
audio.controls = true // 显示控件
audio.crossOrigin = 'anonymous'
audio.id = ele
audio.hidden = true
!state && document.body.appendChild(audio)

/**
 * 播放音乐
 * @param url 【播放地址】
 * @param isOld 【是否为旧地址】
 */
export function AudioPlay ({ url, isOld, volume, initial }) {
    console.log(url, isOld, initial)
    if (!isOld) {
        audio.src = url // 音乐路径
    }
    if(!initial){
        if(volume!==undefined){
            audio.volume = volume / 100
        } else {
            audio.volume = 1
        }
        audio.play()
        // isPlaying = true
        // audio.addEventListener('ended', function () {
        //     isPlaying = false
        // })
    }
}

/**
 * 播放音乐
 * @param url 【播放地址】
 * @param isOld 【是否为旧地址】
 */
export function AudioPlay2 ({ url, endCallBack }) {
    audio.src = url // 音乐路径
    audio.play()
    // isPlaying = true
    audio.addEventListener('ended', function () {
        endCallBack(url)
        // isPlaying = false
    })
}

/**
 * 暂停音乐
 */
export function AudioPause () {
    // if(isPlaying) {
        audio.pause && audio.pause()
    // }
}

/**
 * 重播音乐
 */
export function AudioRePlay () {
    audio = document.getElementById(ele)
    audio.currentTime = 0
    audio.play()
}

/**
 * 设置当前播放时间位置
 */
export function AudioCurTime (time) {
    audio.currentTime = time
}

/**
 * 获取音频总时长 分:秒
 */
export function AudioAllTime (callback, index) {
    const func = () => {
        callback(getTimeFormat(audio.duration), index)
        audio.removeEventListener('canplay', func)
    }
    audio.addEventListener('canplay', func)
}

// 实时获取音频播放时间
export function AudioWatchTime (callback, index) {
    const fn = () => { // 监听音频播放的实时时间事件
        if(TempIndex === index) {
            callback(getTimeFormat(Math.ceil(audio.currentTime)), index)
        }
    }
    if(TempIndex !== index) {
        TempIndex = index
        audio.removeEventListener('timeupdate', fn, false)
    }
    // 监听播放时间
    // 使用事件监听方式捕捉事件
    audio.addEventListener('timeupdate', fn , false)
}

// 音频销毁
export function AudioDestory({url}) {
    if(`${audio.src}` === `${url}`){
        AudioPause()
    }
}

// 换算时间
export function getTimeFormat (time) {
    // 分钟
    const minute = time / 60
    let minutes = parseInt(minute)
    if (minutes < 10) {
        minutes = '0' + minutes
    }
    // 秒
    const second = time % 60
    let seconds = Math.ceil(second)
    if (seconds < 10) {
        seconds = '0' + seconds
    }
    // console.log(parseInt(minutes) * 60 + parseInt(seconds), (minutes * 60 + ':' + seconds))
    // debugger
    return { seconds: parseInt(minutes) * 60 + parseInt(seconds), displayTime: (minutes + ':' + seconds) }
}

/**
 * 文字转语言 【百度】
 */
export function Word2Voice ({text, per, spd= 5, vol = 15}) {
    let url = `https://tts.baidu.com/text2audio?cuid=baike&lan=ZH&ctp=1&pdt=301&rate=32`
    if(Number.isInteger(per)) url += `&per=${per}`
    if(Number.isInteger(spd)) url += `&spd=${spd}`
    if(Number.isInteger(vol)) url += `&vol=${vol}`
    if(text) url += `&tex=${text}`
    console.log('百度语音==>', url)
    const n = document.createElement('AUDIO')
    n.src = url //'https://tts.baidu.com/text2audio?cuid=baike&lan=ZH&ctp=1&pdt=301&vol=9&rate=32&per=4&tex=试试这个'
    n.crossOrigin = 'anonymous'
    n.play()
}

/**
 * 文字转语言 【阿里云】
 */
export function Word2VoiceByAliyun ({text, per, spd= 5, vol = 15}) {
    let url = `https://ucenter.yunkedun.com/api/audio-synthesis/cloud`
    if(Number.isInteger(per)) url += `&voice=${per}`
    if(Number.isInteger(spd)) url += `&speech_rate=${spd}`
    if(Number.isInteger(vol)) url += `&volume=${vol}`
    if(text) url += `&work=${text}`
    console.log('阿里云语音==>', url)
    const n = document.createElement('AUDIO')

    n.src = url //'https://tts.baidu.com/text2audio?cuid=baike&lan=ZH&ctp=1&pdt=301&vol=9&rate=32&per=4&tex=试试这个'
    n.crossOrigin = 'anonymous'
    n.play()
}

/**
 * 文字转语言 【百度地址】
 */
export function Word2VoiceUrl ({text, per, spd= 5, vol = 15}) {
    let url = `https://tts.baidu.com/text2audio?cuid=baike&lan=ZH&ctp=1&pdt=301&rate=32`
    if(Number.isInteger(per)) url += `&per=${per}`
    if(Number.isInteger(spd)) url += `&spd=${spd}`
    if(Number.isInteger(vol)) url += `&vol=${vol}`
    if(text) url += `&tex=${text}`
    return url
}

/**
 * 文字转语言 【阿里云地址】
 */
export function Word2VoiceUrlByAliyun ({text, per, spd= 0, vol = 50}) {
    let url = `https://ucenter.yunkedun.com/api/audio-synthesis/cloud`
    if(Number.isInteger(per)) url += `&voice=${per}`
    if(Number.isInteger(spd)) url += `&speech_rate=${spd}`
    if(Number.isInteger(vol)) url += `&volume=${vol}`
    if(text) url += `&work=${text}`
    return url
}

